import {useCurrentRefinements} from "react-instantsearch";

export default function AisActiveRefinements() {
    const {items, refine} = useCurrentRefinements();

    if (items.length === 0) {
        return null;
    }

    return (
        <div className="ais-activeRefinements">
            {items.map((item) =>
                item.refinements.map((refinement) => (
                    <button
                        key={`${item.attribute}-${refinement.value}`}
                        className="ais-activeRefinements__item tag"
                        onClick={() => refine(refinement)}
                        type="button"
                    >
                        <span className="ais-activeRefinements__label">
                            {refinement.label}
                        </span>
                        <i className="icon icon-close" aria-hidden="true" />
                    </button>
                ))
            )}
        </div>
    );
}